import React from "react";

/**
 * Componente para mostrar mensajes en un formulario.
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.message - Mensaje a mostrar.
 * @param {string} props.type - Tipo de mensaje. Puede ser "error" o "success".
 * @param {string} props.id - Identificador de la casilla de verificación.
 * @returns {JSX.Element} Elemento JSX que representa el componente.
 */
export const FormMessage = ({ message, type, id }) => {
	if (!message) return null;

	const isError = type === "error";

	return (
		<p
			id={id}
			role={isError ? "alert" : "status"}
			aria-live={isError ? "assertive" : "polite"}
			className={`${
				isError ? "red-inverse--color" : "green-inverse--color"
			} font-weight-bold`}
		>
			{message}
		</p>
	);
};
